import { GroupOption, LabelValue } from '@/app/ui/components/OptionBox/interfaces';

export enum UserType {
  SELECTED = 'SELECTED_USERS',
  LOGIN = 'ALL_LOGIN_USERS',
  PHONE_NUMBER = 'ALL_USER_BY_PHONE_NUMBER',
  MEMBERSHIP = 'ALL_USER_BY_MEMBERSHIP_LEVEL'
}

export enum TriggerType {
  PAID_ALL = 'INVOICE_PAID_ALL',
  SHIPMENT_PAID_BY_CITY = 'SHIPMENT_PAID_BY_CITY',
  REFERRAL_INVITEE = 'REFERRAL_INVITEE',
  REFERRAL_CODE_USED = 'REFERRAL_SOURCE',
  REGISTRATION = 'REGISTRATION',
  ON_SCHEDULE = 'ON_SCHEDULE',
  COMPLETE_PROFILE = 'COMPLETE_PROFILE',
}

export enum PointValueType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage'
}

export const TARGET_OPTIONS: Array<LabelValue<UserType>> = [
  { label: 'Selected Users', value : UserType.SELECTED },
  { label: 'All Login Users', value: UserType.LOGIN },
  { label: 'All User by Phone Number', value: UserType.PHONE_NUMBER },
  { label: 'All User by Membership Level', value: UserType.MEMBERSHIP },
]

export const BUDGET_SOURCE: Array<LabelValue<string>> = [
  { label: 'Marketing', value: 'MARKETING' },
  { label: 'Operation', value: 'OPERATION' },
  { label: 'Product', value: 'PRODUCT' },
  { label: 'UX', value: 'UX' },
  { label: 'QA', value: 'QA' },
  { label: 'CS', value: 'CS' },
  { label: 'HRD', value: 'HRD' },
  { label: 'Others', value: 'OTHERS' },
]

export const INVOICE_SOURCE: GroupOption<string, string>[] = [
  {
    group: 'CA',
    options: [
      { label: 'Pickup Regular', value: 'PICKUP' },
      { label: 'Pickup Favorit', value: 'PICKUP_FAVORITE' },
      { label: 'Dropoff Regular', value: 'DROPOFF' },
      { label: 'Dropoff Favorit', value: 'DROPOFF_FAVORITE' },
      { label: 'Shop', value: 'SHOP' },
    ],
  },
  { label: 'Marketplace', value: 'MARKETPLACE' },
  { label: 'POS', value: 'POS'},
]

export const INVOICE_SOURCE_MEMBERSHIP: GroupOption<string, string>[] = [
  {
    group: 'CA',
    options: [
      { label: 'Pickup Regular', value: 'PICKUP' },
      { label: 'Pickup Favorit', value: 'PICKUP_FAVORITE', disabled: true },
      { label: 'Dropoff Regular', value: 'DROPOFF' },
      { label: 'Dropoff Favorit', value: 'DROPOFF_FAVORITE', disabled: true },
      { label: 'Shop', value: 'SHOP', disabled: true },
    ],
  },
  { label: 'Marketplace', value: 'MARKETPLACE', disabled: true },
  { label: 'POS', value: 'POS' , disabled: true },
]

export const MEMBERSHIP_LEVEL: Array<LabelValue<string>> = [
  {
    label: 'Premium',
    value: 'Premium'
  },
  {
    label: 'Regular',
    value: 'Regular'
  },
  {
    label: 'Basic',
    value: 'Basic'
  },
]

const noteReferral = 'Referral points are eligible for users who has made first transaction and never deleted their account'

export const TRIGGERED_BY_NOTE: Record<string, string> = {
  [TriggerType.REFERRAL_CODE_USED]: noteReferral,
  [TriggerType.REFERRAL_INVITEE]: noteReferral,
  [TriggerType.REGISTRATION]: 'Registration points are eligible for users who has never deleted their account',
}
